const InfoCasasBrand = require("./InfoCasasBrand");
const CasasEnElEsteBrand = require("./CasasEnElEsteBrand");
const CasasYMasBrand = require("./CasasYMasBrand");
const FincaraizBrand = require("./FincaraizBrand");
const YapoBrand = require("./YapoBrand");
const Encuentra24Brand = require("./Encuentra24Brand");

const getBranding = appTheme => {
	switch (appTheme) {
		case "casaseneleste":
			return CasasEnElEsteBrand;
		case "casasymas":
			return CasasYMasBrand;
		case "infocasas":
			return InfoCasasBrand;
		case "encuentra24":
			return Encuentra24Brand;
		case "yapo":
			return YapoBrand;
		case "fincaraiz":
			return FincaraizBrand;
		default:
			return InfoCasasBrand;
	}
};

module.exports = { getBranding };

